import React, { useEffect, useState } from "react";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import POLogo from "../../assets/svg/pologo.svg";
import left from "../../assets/svg/backArrow.svg";
import productIc from "../../assets/png/productIc.png";
import locationIc from "../../assets/svg/location.svg";
import mail from "../../assets/svg/mail.svg";
import phone from "../../assets/svg/phone.svg";
import email_lg from "../../assets/svg/email_lg.svg";
import contact_lg from "../../assets/svg/contact_lg.svg";
import user from "../../assets/svg/user.svg";
import tickGreen from "../../assets/svg/tick_green.svg";
import wrongRed from "../../assets/svg/wrong_red.svg";
import requestImg from "../../assets/svg/request_img.svg";
import createdImg from "../../assets/svg/created_img.svg";
import "../common/Util.css";
import "./POV.css";
import {
  deletePoApi,
  getPODownloadApi,
  getPOViewApi,
  updateStatusApi,
} from "./purchase-api";
import { apiCall } from "../../services/api-service.js";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { Button, Nav, Toast, ToastContainer, Modal, Form } from "react-bootstrap";
import LoaderModal from "../common/loader";
import DeleteModal from "../common/deleteModel";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { useGlobal } from "../../GlobalContext";
import { getVendorAddress } from "../purchase-quotation/pq-api";
import numberFormat from "../common/number-format";
import ProfileImageModal from "../common/common-preview";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import AmountSummary from "../common/AmountSummary";
export const PurchaseOrderView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [templateLoading, setTemplateLoading] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] = useState(false);
  const hasValue = (value) =>
    value !== null && value !== undefined && value.toString().trim() !== "";

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const [activeTab, setActiveTab] = useState("details");
  const [subTab, setSubTab] = useState("products");
  const { id } = location.state || {};
  const from = location.state?.from;

  const subTabStyle = (isActive) => ({
    padding: "8px 16px",
    borderRadius: "100px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    border: isActive ? "none" : "1px solid #EBEBEB",
    backgroundColor: isActive ? "#4F46E5" : "#FFFFFF",
    color: isActive ? "#FFFFFF" : "#212129",
  });
  const tabs = [
    { key: "details", label: "Details" },
    { key: "term", label: "Terms & Condition" },
  ];

  const navItemStyle = (isActive) => ({
    padding: "0px 12px",
    marginRight: "10px",
    borderRadius: "20px",
    height: 36,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    color: isActive ? "#FFFFFF" : "#212129",
    backgroundColor: isActive ? "#4F46E5" : "#FFFFFF",
    border: isActive ? "1.5px solid #4F46E5" : "1px solid #EBEBEB",
    boxShadow: isActive ? "none" : "none",
  });

  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "po",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/purchase-order");
    }
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  // table
  const [products, setProducts] = useState([]);
  const [poDetails, setPoDetails] = useState({});
  const [stageListOption, setListStageOption] = useState([
    { value: "Cancelled", label: "Cancelled" },
    { value: "Confirmed", label: "Confirmed" },
  ]);
  const [isEligibleApprover, setIsEligibleApprover] = useState(false);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [canReject, setCanReject] = useState(false);
  const [commentsMandatory, setCommentsMandatory] = useState(false);

  const fetchApprovalHistory = async (docId) => {
    try {
      const response = await apiCall("get", `approval_history/${docId}`, null, {
        params: { type: "purchase_order" }
      });
      if (response.data?.success) {
        const historyList = response.data.histories ?? [];
        setApprovalHistory(historyList);
        const isEligible = response.data.is_eligible ?? false;
        setIsEligibleApprover(isEligible);
        setCanReject(response.data.can_reject ?? false);
        setCommentsMandatory(response.data.comments_mandatory ?? false);
      }
    } catch (e) {
      console.error("Error fetching approval history", e);
    }
  };

  const handleApprovalActionClick = (action) => {
    if (action === "REJECT" && !canReject) {
      alert("Reject action is not allowed for this level.");
      return;
    }
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(commentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    setIsLoading(true);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: id,
        document_type: "purchase_order",
        action: approvalAction,
        comments: approvalComments
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getPoView();
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  useEffect(() => {
    if (id != null) {
      getPoView();
    }
  }, []);
  const [isIgst, setIsIgst] = useState(false);
  const [isCgst, setIsCgst] = useState(false);
  const [isSgst, setIsSgst] = useState(false);
  const getAddress = async (id) => {
    try {
      const response = await getVendorAddress(id);
      if (response.data.success === true) {
        setIsIgst(response.data.data.igst ?? false);
        setIsCgst(response.data.data.cgst ?? false);
        setIsSgst(response.data.data.sgst ?? false);
      }
    } catch (e) { }
  };
  const getPoView = async () => {
    try {
      const response = await getPOViewApi(id);
      console.log("response", response);
      if (response.data.success === true) {
        const order = response.data.order ?? {};
        if (order.currency_symbol) {
          order.currency_symbol = decodeHtml(order.currency_symbol);
        }
        setPoDetails(order);
        getAddress(order.vendor_id ?? "");
        if (order.approval_config_id) {
          fetchApprovalHistory(order.id);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getPoDownload = async () => {
    if (templateLoading) return;
    setTemplateLoading(true);
    try {
      const response = await getPODownloadApi(id);
      console.log("response", response);
      if (response.data.success === true) {
        downloadPdfFromBase64(response.data.base64, response.data.file_name ? response.data.file_name + '.pdf' : 'document.pdf');
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setTemplateLoading(false);
    }
  };
  const downloadPdfFromBase64 = (base64, fileName = "document.pdf") => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const [isLoading, setIsLoading] = useState(false);

  const updateStatus = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      const response = await updateStatusApi(id, bodyData);
      console.log("response....1", response);
      if (response.success === true) {
        getPoView();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const tableHeaders = [
    "Name",
    "Product ID",
    "Unit",
    "Exp. Delivery Date",
    "Quantity",
    "Unit Price",
    ...(isCgst ? ["CGST (%)"] : []),
    ...(isIgst ? ["IGST (%)"] : []),
    ...(isSgst ? ["SGST (%)"] : []),
    "Total Amount",
    "",
  ];
  const transDetails = [
    {
      id: 28,
      trans_amount: "1001",
      payment_type: "Cash",
      date: "06 Oct 2025 at 11:54 AM",
      user: "Arun ",
      balance_amount: 40,
    },
    {
      id: 28,
      trans_amount: "1001",
      payment_type: "Cash",
      date: "06 Oct 2025 at 11:54 AM",
      user: "Ragu-",
      balance_amount: 0,
    },
    {
      id: 27,
      trans_amount: "1001",
      payment_type: "Cash",
      date: "06 Oct 2025 at 11:33 AM",
      user: "Arun ",
      balance_amount: 0,
    },
    {
      id: 27,
      trans_amount: "1001",
      payment_type: "Cash",
      date: "06 Oct 2025 at 11:33 AM",
      user: "Ragu-",
      balance_amount: 10,
    },
    {
      id: 26,
      trans_amount: "1001",
      payment_type: "Cash",
      date: "06 Oct 2025 at 11:30 AM",
      user: "Arun ",
      balance_amount: 0,
    },
  ];

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  // delete Api
  const deletePo = async () => {
    // setIsLoading(true);
    try {
      const response = await deletePoApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getPoView();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
        handleBack();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");

  const toNumber = (v) => {
    if (v === null || v === undefined) return 0;
    const cleaned = String(v).replace(/,/g, "").trim();
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  const calculatePoSummary = (po) => {
    let subTotal = 0;
    let cgstTotal = 0;
    let sgstTotal = 0;
    let igstTotal = 0;

    po.products?.forEach((row) => {

      const base =
        toNumber(row.quantity) * toNumber(row.unit_without_tax);

      subTotal += base;
      cgstTotal += base * (toNumber(row.cgst_percentage) / 100);
      sgstTotal += base * (toNumber(row.sgst_percentage) / 100);
      igstTotal += base * (toNumber(row.igst_percentage) / 100);
    });

    const grossTotal = subTotal + cgstTotal + sgstTotal + igstTotal;
    const roundDiff = toNumber(po.round_diff);

    return {
      subTotal,
      cgstTotal,
      sgstTotal,
      igstTotal,
      roundDiff,
      finalTotal: grossTotal + roundDiff,
    };
  };

  const summary = calculatePoSummary(poDetails);


  return (
    <div>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"vendor"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deletePo}
      />
      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT" ? "Reject Purchase Order" : "Approve Purchase Order"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT" 
                ? "Enter reason for rejection" 
                : "Enter comments"
              }
              {approvalCommentsMandatory && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
            style={approvalAction !== "REJECT" ? { backgroundColor: "#2563EB", borderColor: "#2563EB" } : {}}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Purchase Order" />
        {/* Main Content */}
        <div className="rounded-4 flex-grow-1">
          <div className="" style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Purchase Order" />
            <div className="p-3 bg-white">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={left}
                    alt="back"
                    onClick={() => {
                      handleBack();
                    }}
                    style={{ border: "1px solid #EBEBEB", cursor: "pointer" }}
                    className="p-3 rounded-circle bg-white"
                  />
                  <img src={POLogo} alt="pologo" />
                  <div className="d-flex flex-column">
                    <p className="m-0 fs-16 fw-400">
                      {poDetails.order_no ?? "-"}
                    </p>
                    <p className="textGrey m-0 fs-13 fw-400">
                      Payment Status :
                      <span className="textPurple fs-13 fw-500">
                        {" "}
                        {poDetails.payment_status ?? "-"}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  {isEligibleApprover && (
                    <div className="d-flex gap-2">
                      <Button
                        variant="success"
                        className="rounded-5 fs-13 fw-600 px-3"
                        style={{ height: "36px", backgroundColor: "#10B981", borderColor: "#10B981" }}
                        onClick={() => handleApprovalActionClick("APPROVE")}
                      >
                        Approve
                      </Button>
                      {canReject && (
                        <Button
                          variant="danger"
                          className="rounded-5 fs-13 fw-600 px-3"
                          style={{ height: "36px", backgroundColor: "#EF4444", borderColor: "#EF4444" }}
                          onClick={() => handleApprovalActionClick("REJECT")}
                        >
                          Reject
                        </Button>
                      )}
                    </div>
                  )}
                  {poDetails.status === "Draft" ? (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                        style={{
                          padding: "6px 12px",
                        }}
                      >
                        <span className="d-flex align-items-center px-1 gap-2">
                          <span
                            className="backgroundYellow"
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "3px",
                              display: "inline-block",
                            }}
                          ></span>

                          <span className="dropdown-text textcolor fs-13 fw-500">
                            {poDetails.status ?? "-"}
                          </span>

                          <span className="dropdown-toggle-arrow">
                            <DownArrowIc />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {stageListOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option}
                            onClick={() =>
                              updateStatus(poDetails.id, option.value)
                            }
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <div
                      style={{
                        padding: "6px 12px",
                        height: "36px",
                      }}
                      className="d-flex align-items-center justify-content-between backgroundLightOrange rounded-5"
                    >
                      <span className="d-flex align-items-center px-1 gap-2">
                        <span
                          className="backgroundYellow"
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            display: "inline-block",
                          }}
                        ></span>

                        <span className="dropdown-text textcolor fs-13 fw-500">
                          {poDetails.status ?? "-"}
                        </span>
                      </span>
                    </div>
                  )}
                  <div
                    className={`my-import d-flex align-items-center justify-content-center gap-2 ${templateLoading ? "disabled" : ""
                      }`}
                    style={{
                      height: "36px",
                      cursor: templateLoading ? "not-allowed" : "pointer",
                      opacity: templateLoading ? 0.7 : 1,
                    }}
                    onClick={!templateLoading ? getPoDownload : undefined}
                  >
                    {templateLoading ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm text-primary"
                          role="status"
                          style={{ width: "14px", height: "14px" }}
                        />
                        <span className="fs-12 fw-600">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <div className="fs-12 fw-600">Download Po</div>
                        <DownloadIc style={{ width: "16px", height: "16px" }} />
                      </>
                    )}
                  </div>
                  {poDetails.status === "Draft" && (
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("Purchase Order", "edit_permission") ||
                        checkPermission(
                          "Purchase Order",
                          "delete_permission",
                        )) && (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id="dropdown-sort"
                              className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                              style={{
                                width: "36px",
                                height: "36px",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <span className="d-flex align-items-center px-1 gap-2">
                                <ThreeDotIC />
                              </span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                border: "1px solid #EBEBEB",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {/* <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              onClick={(e) => {
                                e.stopPropagation();
                                getPoDownload();
                              }}
                            >
                              Download Po
                            </Dropdown.Item> */}
                              {checkPermission(
                                "Purchase Order",
                                "edit_permission",
                              ) && (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate("/po/create", {
                                        state: { id: id },
                                      });
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                )}
                              {checkPermission(
                                "Purchase Order",
                                "delete_permission",
                              ) && (
                                  <Dropdown.Item
                                    className="fs-14 fw-500 textcolor"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDeleteId(id);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      {/* <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                          style={{
                            width: "36px",
                            height: "36px",
                            border: "1px solid #EBEBEB",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <ThreeDotIC />
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/po/create", {
                                state: { id: id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex mt-3 gap-3">
                <div
                  className="px-3 rounded-pill"
                  style={{ backgroundColor: "#F8F8FF" }}
                >
                  <p className="fs-12 fw-300 m-0">
                    Total : &nbsp;{" "}
                    <span className="fs-14 fw-500">
                      {poDetails.currency_symbol || "₹"} {numberFormat(poDetails.total_amount ?? "0")}
                    </span>
                  </p>
                </div>
                <div
                  className="px-3 rounded-pill"
                  style={{ backgroundColor: "#E2FFEE" }}
                >
                  <p className="fs-12 fw-300 m-0">
                    Paid : &nbsp;{" "}
                    <span className="fs-14 fw-500 cardTextGreen">
                      {" "}
                      {poDetails.currency_symbol || "₹"} {numberFormat(poDetails.paid_amount ?? "0")}
                    </span>
                  </p>
                </div>
                <div
                  className="px-3 rounded-pill"
                  style={{ backgroundColor: "#FFEAEA" }}
                >
                  <p className="fs-12 fw-300 m-0">
                    Balance : &nbsp;{" "}
                    <span className="fs-14 fw-500 cardTextRed">
                      {" "}
                      {poDetails.currency_symbol || "₹"} {numberFormat(poDetails.balance_amount ?? "0")}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <Nav
              style={{
                marginTop: "10px",
                paddingLeft: "10px",
                paddingTop: "10px",
                marginBottom: "10px",
                gap: "4px",
                display: "flex",
                justifyContent: "start",
                flexWrap: "nowrap",
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                scrollbarWidth: "thin",
              }}
            >
              {tabs.map((tab) => (
                <Button
                  key={tab.key}
                  sty
                  style={navItemStyle(activeTab === tab.key)}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </Button>
              ))}
            </Nav>
            {activeTab === "details" && (
              <div className="p-3">
                <div className="row g-4">
                  {/* Left Column: Order details */}
                  <div className="col-lg-6">
                    <div className="bg-white rounded-4 p-4 h-100">
                      <p className="fs-16 fw-600 mb-3" style={{ color: "#212129" }}>Order details</p>

                      {/* PO Number (Commented out as per new UI request) */}
                      {/*
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            PO Number
                          </p>
                        </div>
                        <div className="col-sm-8">
                          <p className="fs-14 fw-500 mb-0">
                            {poDetails.po_number ?? "-"}
                          </p>
                        </div>
                      </div>
                      */}

                      {/* PO Date (Commented out as per new UI request) */}
                      {/*
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            PO Date
                          </p>
                        </div>
                        <div className="col-sm-8">
                          <p className="fs-14 fw-500 mb-0">
                            {poDetails.po_date ?? "-"}
                          </p>
                        </div>
                      </div>
                      */}

                      {/* Currency */}
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4 col-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Currency
                          </p>
                        </div>
                        <div className="col-sm-8 col-8">
                          <p className="fs-14 fw-500 mb-0 text-dark">
                            {poDetails.currency_name ?? "-"} ({poDetails.currency_symbol || "₹"})
                          </p>
                        </div>
                      </div>

                      {/* Category (Commented out as per new UI request) */}
                      {/*
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Category
                          </p>
                        </div>
                        <div className="col-sm-8">
                          <p className="fs-14 fw-500 mb-0">
                            {poDetails.category_name ?? "-"}
                          </p>
                        </div>
                      </div>
                      */}

                      {/* Payment Type (Commented out as per new UI request) */}
                      {/*
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Payment Type
                          </p>
                        </div>
                        <div className="col-sm-8">
                          <p className="fs-14 fw-500 mb-0">
                            {poDetails.payment_type ?? "-"}
                          </p>
                        </div>
                      </div>
                      */}

                      {/* Vendor owner */}
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4 col-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Vendor owner
                          </p>
                        </div>
                        <div className="col-sm-8 col-8">
                          <p
                            style={{ color: "#3875FB" }}
                            className="d-flex fs-14 fw-500 gap-2 mb-0 align-items-center"
                          >
                            <img src={user} alt="user" />
                            {poDetails.owner ?? "-"}
                          </p>
                        </div>
                      </div>

                      {/* Exp. delivery date */}
                      <div className="row mb-3 align-items-center">
                        <div className="col-sm-4 col-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Exp. delivery date
                          </p>
                        </div>
                        <div className="col-sm-8 col-8">
                          <p className="fs-14 fw-500 mb-0 text-dark">
                            {poDetails.date ?? "-"}
                          </p>
                        </div>
                      </div>

                      {/* Description */}
                      <div className="row mb-3 align-items-start">
                        <div className="col-sm-4 col-4">
                          <p className="fs-14 fw-400 mb-0" style={{ color: "#8790A1" }}>
                            Description
                          </p>
                        </div>
                        <div className="col-sm-8 col-8">
                          <p className="fs-14 fw-500 mb-0 text-muted-dark" style={{ whiteSpace: "pre-line" }}>
                            {poDetails.description ?? "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Vendor details */}
                  <div className="col-lg-6">
                    <div className="bg-white rounded-4 p-4 h-100">
                      <p className="fs-16 fw-600 mb-3" style={{ color: "#212129" }}>Vendor details</p>
                      <div
                        className="rounded-4 p-4"
                        style={{ backgroundColor: "#FAFAFA", width: "100%" }}
                      >
                        <div className="d-flex gap-3 align-items-center">
                          <div className="profile-wrapper bg-white shadow-sm flex-shrink-0">
                            <img
                              src={
                                poDetails.image && poDetails.image.trim() !== ""
                                  ? poDetails.image
                                  : profileIc
                              }
                              alt="Profile"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedProfile(
                                  poDetails.image && poDetails.image.trim() !== ""
                                    ? poDetails.image
                                    : profileIc,
                                );
                                setShowProfilePopup(true);
                              }}
                              style={{ cursor: "pointer" }}
                              className="profile-img"
                            />
                            <div className="profile-badge fs-11">
                              {poDetails.grade_name ?? "-"}
                            </div>
                          </div>
                          <div className="d-flex flex-column">
                            <p className="fs-16 fw-600 m-0 text-dark">
                              {poDetails.company_name ?? "-"}
                            </p>
                            <div className="d-flex align-items-center gap-2 mt-1 flex-wrap">
                              <p className="fs-13 fw-400 m-0 d-flex gap-1 align-items-center text-secondary">
                                <img src={locationIc} alt="loc" style={{ width: "14px", height: "14px" }} />
                                {poDetails.city_name ?? "-"}
                              </p>
                              <div
                                className="rounded-circle"
                                style={{
                                  backgroundColor: "#D9D9D9",
                                  width: "4px",
                                  height: "4px",
                                }}
                              ></div>
                              <p className="m-0 backgroundBlue textBlue rounded-pill px-3 py-1 fs-12 fw-500">
                                {poDetails.industry_name ?? "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-2 mt-3 flex-wrap">
                          <p
                            className="m-0 d-flex fs-13 fw-400 text-dark align-items-center"
                            style={{
                              backgroundColor: "#EEEEEE",
                              borderRadius: "100px",
                              padding: "8px 12px 8px 8px",
                              gap: "8px",
                              height: "32px",
                              width: "fit-content"
                            }}
                          >
                            <img src={email_lg} alt="mail" className="flex-shrink-0" style={{ width: "22px", height: "22px" }} />
                            {poDetails.vendor_email ?? "-"}
                          </p>
                          <div
                            className="d-none d-sm-block text-secondary fs-14 fw-bold mx-1"
                          >
                            ·
                          </div>
                          <p
                            className="m-0 fs-13 fw-400 d-flex text-dark align-items-center"
                            style={{
                              backgroundColor: "#EEEEEE",
                              borderRadius: "100px",
                              padding: "8px 12px 8px 8px",
                              gap: "8px",
                              height: "32px",
                              width: "fit-content"
                            }}
                          >
                            <img src={contact_lg} alt="phone" className="flex-shrink-0" style={{ width: "22px", height: "22px" }} />
                            {poDetails.vendor_phone ?? "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*
                <div className="bg-white rounded-4 p-3 mt-3">
                  <p className="fs-16 fw-600">Vendor details</p>
                  <div
                    className="rounded-4 p-3 pe-4"
                    style={{ backgroundColor: "#FAFAFA", width: "fit-content" }}
                  >
                    <div className="d-flex gap-3">
                      <div className="profile-wrapper bg-white">
                        <img
                          src={
                            poDetails.image && poDetails.image.trim() !== ""
                              ? poDetails.image
                              : profileIc
                          }
                          alt="Profile"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(
                              poDetails.image && poDetails.image.trim() !== ""
                                ? poDetails.image
                                : profileIc,
                            );
                            setShowProfilePopup(true);
                          }}
                          style={{ cursor: "pointer" }}
                          className="profile-img"
                        />
                        <div className="profile-badge fs-11">
                          {poDetails.grade_name ?? "-"}
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="fs-16 fw-400 m-0">
                          {" "}
                          {poDetails.company_name ?? "-"}
                        </p>
                        <div className="d-flex align-items-center gap-3">
                          <p className="fs-13 fw-400 m-0 d-flex gap-1">
                            <img src={locationIc} alt="loc" />
                            {poDetails.city_name ?? "-"}
                          </p>
                          <div
                            className="rounded-circle"
                            style={{
                              backgroundColor: "#D9D9D9",
                              width: "4px",
                              height: "4px",
                            }}
                          ></div>
                          <p className="m-0 backgroundBlue textBlue rounded-pill px-3 py-1">
                            {poDetails.industry_name ?? "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-3 mt-2">
                      <p
                        className="m-0 rounded-pill px-2 py-1 d-flex gap-2 fs-13 fw-400"
                        style={{ backgroundColor: "#EEEEEE" }}
                      >
                        <img src={mail} alt="mail" />
                        {poDetails.vendor_email ?? "-"}
                      </p>
                      <div
                        className="rounded-circle"
                        style={{
                          backgroundColor: "#D9D9D9",
                          width: "4px",
                          height: "4px",
                        }}
                      ></div>
                      <p
                        className="m-0 fs-13 fw-400 rounded-pill px-2 py-1 d-flex gap-2"
                        style={{ backgroundColor: "#EEEEEE" }}
                      >
                        <img src={phone} alt="phone" />
                        {poDetails.vendor_phone ?? "-"}
                      </p>
                    </div>
                  </div>
                  <div className="row mt-3 align-items-center">
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        PO Number
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500">
                        {" "}
                        {poDetails.po_number ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        PO Date
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500">
                        {" "}
                        {poDetails.po_date ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Currency
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500">
                        {" "}
                        {poDetails.currency_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Category
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500">
                        {" "}
                        {poDetails.category_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Payment Type
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500">
                        {" "}
                        {poDetails.payment_type ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Vendor owner
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p
                        style={{ color: "#3875FB" }}
                        className="d-flex fs-14 fw-500 gap-2"
                      >
                        <img src={user} alt="user" />
                        {poDetails.owner ?? "-"}
                      </p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Exp. delivery date
                      </p>
                    </div>
                    <div className="col-xl-10">
                      <p className="fs-14 fw-500"> {poDetails.date ?? "-"}</p>
                    </div>
                    <div className="col-xl-2">
                      <p className="fs-14 fw-400" style={{ color: "#8790A1" }}>
                        Description
                      </p>
                    </div>
                    <div className="col-xl-6">
                      <p className="fs-14 fw-500">
                        {poDetails.description ?? "-"}
                      </p>
                    </div>
                  </div>
                </div>
                */}
                <div className="d-flex gap-3 mt-4">
                  <div
                    style={subTabStyle(subTab === "products")}
                    onClick={() => setSubTab("products")}
                  >
                    Products ({poDetails?.products?.length || 0})
                  </div>
                  <div
                    style={subTabStyle(subTab === "transactions")}
                    onClick={() => setSubTab("transactions")}
                  >
                    Transactions ({poDetails?.transactions?.length || 0})
                  </div>
                  <div
                    style={subTabStyle(subTab === "approvals")}
                    onClick={() => setSubTab("approvals")}
                  >
                    Approval History ({approvalHistory?.length || 0})
                  </div>
                </div>

                {subTab === "products" && (
                <div className="bg-white p-3 rounded-4 mt-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="m-0 fs-16 fw-600">Product details</p>
                    {/* <button className="border-0 rounded-pill fs-13 fw-600 px-3 py-2 d-flex gap-1 align-items-center backgroundGreen text-white">
                    <img src={plus} alt="plus" />
                    Add product
                  </button> */}
                  </div>
                  <div className="custom-table-wrapper mt-3 shadow-sm rounded">
                    <table className="table custom-table table-borderless align-middle mb-0">
                      <thead>
                        <tr>
                          {tableHeaders.map((header, index) => (
                            <th
                              className="fs-13 fw-700"
                              key={index}
                              style={{
                                backgroundColor: "#F2F2F2",
                                color: "#212129",
                              }}
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {poDetails?.products?.map((item, index) => (
                          <React.Fragment key={item.id}>
                            <tr className="fs-13 fw-400">
                              <td className="text-start d-flex align-items-center gap-2">
                                <img
                                  src={
                                    item.image && item.image.trim() !== ""
                                      ? item.image
                                      : productIc
                                  }
                                  alt="Profile"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedProfile(
                                      item.image && item.image.trim() !== ""
                                        ? item.image
                                        : productIc,
                                    );
                                    setShowProfilePopup(true);
                                  }}
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                  }}
                                  className="profile-img"
                                />
                                <span>{item.name ?? ""}</span>
                              </td>
                              <td>{item.code ?? ""}</td>
                              <td>{item.unit_name ?? ""}</td>
                              <td>{item.date ?? ""}</td>
                              <td>{item.quantity ?? "0"}</td>
                              <td>
                                {poDetails.currency_symbol || "₹"}{numberFormat(item.unit_without_tax ?? "0")}
                              </td>
                              {isCgst && (
                                <td>{item.cgst_percentage ?? "0"}%</td>
                              )}
                              {isIgst && (
                                <td>{item.igst_percentage ?? "0"}%</td>
                              )}
                              {isSgst && (
                                <td>{item.sgst_percentage ?? "0"}%</td>
                              )}
                              <td>{poDetails.currency_symbol || "₹"}{numberFormat(item.total_amount ?? "0")}</td>
                              {/* <td>{item.tds_percentage ?? "0"}%</td> */}

                              {/* <td>
                              <img src={trash} alt="trash" />
                            </td> */}
                            </tr>

                            {/* Divider row */}
                            {index !== products.length - 1 && (
                              <tr>
                                <td colSpan="10">
                                  <hr
                                    className="m-0"
                                    style={{ borderColor: "#E0E0E0" }}
                                  />
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <AmountSummary
                    subTotal={summary.subTotal}
                    cgst={summary.cgstTotal}
                    sgst={summary.sgstTotal}
                    igst={summary.igstTotal}
                    roundOff={Number(poDetails.round_diff)}
                    showRoundOff={Number(poDetails.round_diff) !== 0}
                    currencySymbol={poDetails.currency_symbol || "₹"}
                  />

                </div>
                )}
                {subTab === "transactions" && (
                <div className="bg-white p-3 rounded-4 mt-3">
                  <p className="fs-16 fw-600">Transaction details</p>
                  <div className="d-flex flex-column ms-3">
                    {poDetails?.transactions?.map((txn, idx) => (
                      <div key={idx} className="d-flex mb-4 position-relative">
                        {/* Green tick */}
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            backgroundColor: "#E6FFF1", // light green outer circle
                            width: "40px",
                            height: "40px",
                            marginRight: "15px",
                            marginLeft: "-19px",
                            zIndex: "1",
                          }}
                        >
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                              backgroundColor: "#4EBD7E", // dark green inner circle
                              width: "20px",
                              height: "20px",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                            }}
                          >
                            ✓
                          </div>
                        </div>

                        {/* Vertical dashed line (only if not last item) */}
                        {idx !== poDetails.transactions.length - 1 && (
                          <div
                            className="position-absolute start-0"
                            style={{
                              borderLeft: "2px dashed #3469E7",
                              height: "calc(100% + 16px)", // extend into mb-4 gap
                              left: "8px",
                              top: "10px", // middle of circle
                            }}
                          />
                        )}

                        {/* Transaction details */}
                        <div className="flex-grow-1">
                          <div className="d-flex align-items-center mb-2">
                            <span
                              className="fw-700 fs-16 me-2"
                              style={{ color: "#2C8C53" }}
                            >
                              {poDetails.currency_symbol || "₹"} {numberFormat(txn.trans_amount ?? "0")}
                            </span>
                            <div
                              className="backgroundGreyDot me-2"
                              style={{ width: "4px", height: "4px" }}
                            ></div>
                            <span
                              className="badge rounded-pill fs-11 fw-600"
                              style={{ backgroundColor: "#4F46E5" }}
                            >
                              {txn.payment_type ?? "-"}
                            </span>
                          </div>
                          <small className="cardTextGrey d-block mb-2 fs-12 fw-400">
                            {txn.date ?? "-"} by {txn.user ?? "-"}
                          </small>
                          <div className="mt-2">
                            {txn.balance_amount === 0 ? (
                              <div
                                className="d-inline-flex align-items-center gap-2 px-2 py-1 text-black fs-11 fw-500 rounded-pill"
                                style={{
                                  backgroundColor: "#E0FFEE",
                                  width: "fit-content", // ✅ forces content width
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center rounded-circle"
                                  style={{
                                    backgroundColor: "#4EBD7E",
                                    width: "18px",
                                    height: "18px",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ✓
                                </span>
                                Paid
                              </div>
                            ) : (
                              <div className="d-flex gap-3">
                                <span
                                  className="px-2 d-flex align-items-center gap-2 py-1 bg-light fs-11 fw-400 rounded-pill"
                                  style={{ width: "fit-content" }}
                                >
                                  <span
                                    className="backgroundYellow"
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "3px",
                                    }}
                                  ></span>
                                  Partially paid
                                </span>
                                <span className="px-2 py-1 bg-light fs-11 fw-400 rounded-pill">
                                  Balance&nbsp;:
                                  <span className="cardTextRed fs-12 fw-500 ms-2">
                                    {poDetails.currency_symbol || "₹"} {numberFormat(txn.balance_amount)}
                                  </span>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                )}
                 {subTab === "approvals" && (
                 <div className="bg-white p-3 rounded-4 mt-3">
                   <p className="fs-16 fw-600">Approval History</p>
                   {approvalHistory && approvalHistory.length > 0 ? (
                     <div className="d-flex flex-column ms-3 mt-3">
                       <div className="position-relative ps-1">
                         {approvalHistory.map((h, idx) => {
                           let icon = tickGreen;
                           let bgLabelColor = "#E6FFF1";
                           let textLabelColor = "#10B981";

                           if (h.status === "Rejected") {
                             icon = wrongRed;
                             bgLabelColor = "#FEE2E2";
                             textLabelColor = "#EF4444";
                           } else if (h.status === "Requested") {
                             icon = requestImg;
                             bgLabelColor = "#DBEAFE";
                             textLabelColor = "#2563EB";
                           } else if (h.status === "Created") {
                             icon = createdImg;
                             bgLabelColor = "#F3F4F6";
                             textLabelColor = "#4B5563";
                           } else if (h.status === "Waiting for approval...") {
                             icon = tickGreen;
                             bgLabelColor = "#F3F4F6";
                             textLabelColor = "#4B5563";
                           }

                           return (
                             <div key={idx} className="d-flex align-items-start position-relative mb-4" style={{ zIndex: 1 }}>
                               {/* Vertical Dashed Line */}
                               {idx !== approvalHistory.length - 1 && (
                                 <div
                                   style={{
                                     position: "absolute",
                                     left: "16px",
                                     top: "22px",
                                     height: "calc(100% + 24px)",
                                     width: "2px",
                                     borderLeft: "2px dashed #D1D5DB",
                                     zIndex: 0,
                                   }}
                                 ></div>
                               )}
                               <div className="me-3" style={{ zIndex: 2, marginTop: "6px" }}>
                                 <img src={icon} alt={h.status} style={{ width: "32px", height: "32px" }} />
                               </div>
                               <div className="d-flex flex-column gap-1">
                                 <div className="d-flex align-items-center gap-2">
                                   <span className="fw-600" style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "14px", color: "#1F2937" }}>
                                     {h.status}
                                   </span>
                                   <span style={{ color: "#9CA3AF" }}>·</span>
                                   <span
                                     style={{
                                       fontFamily: "'Lexend Deca', sans-serif",
                                       fontSize: "12px",
                                       fontWeight: "500",
                                       backgroundColor: bgLabelColor,
                                       color: textLabelColor,
                                       padding: "2px 8px",
                                       borderRadius: "4px"
                                     }}
                                   >
                                     {h.user_name}
                                   </span>
                                 </div>
                                 {h.comments && (
                                   <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "13px", color: "#4B5563" }}>
                                     {h.comments}
                                   </span>
                                 )}
                                 <span style={{ fontFamily: "'Lexend Deca', sans-serif", fontSize: "12px", color: "#9CA3AF" }}>
                                   {h.date_time}
                                 </span>
                               </div>
                             </div>
                           );
                         })}
                       </div>
                     </div>
                   ) : (
                     <div className="text-center py-4 text-muted">No approval history found.</div>
                   )}
                 </div>
                 )}
              </div>
            )}
            {activeTab === "term" && (
              <div className="container my-4">
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-body p-4">
                    {/* Payment Terms */}
                    <div className="mb-4">
                      <h6 className="fw-600 fs-15 textcolor mb-2">
                        Payment Terms
                      </h6>
                      <p className="fw-300 fs-13 textcolor mb-0 ">
                        {hasValue(poDetails.payment_terms)
                          ? (poDetails.payment_terms ?? "-")
                          : "-"}
                      </p>
                    </div>
                    {hasValue(poDetails.payment_terms) && (
                      <hr className="section-divider" />
                    )}

                    {/* Inco Terms */}
                    <div className="mb-4">
                      <h6 className="fw-600 fs-15 textcolor mb-2">
                        Inco Terms
                      </h6>
                      <p className="fw-300 fs-13 textcolor">
                        {hasValue(poDetails.inco_terms)
                          ? (poDetails.inco_terms ?? "-")
                          : "-"}
                      </p>
                    </div>

                    {hasValue(poDetails.inco_terms) && (
                      <hr className="section-divider" />
                    )}

                    {/* Notes & Instructions */}
                    <div className="mb-4">
                      <h6 className="fw-600 fs-15 textcolor mb-2">
                        Notes &amp; Instructions
                      </h6>

                      <p className="fw-300 fs-13 textcolor">
                        {hasValue(poDetails.note_instruction)
                          ? (poDetails.note_instruction ?? "-")
                          : "-"}
                      </p>
                    </div>

                    {hasValue(poDetails.note_instruction) && (
                      <hr className="section-divider" />
                    )}

                    {/* Terms & Conditions */}
                    <div>
                      <h6 className="fw-600 fs-15 textcolor mb-2">
                        Terms &amp; Conditions
                      </h6>

                      <p className="fw-300 fs-13 textcolor">
                        {hasValue(poDetails.terms_condition)
                          ? (poDetails.terms_condition ?? "-")
                          : "-"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Authorized Signature */}
                {poDetails.sign_image && (
                  <div className="card shadow-sm border-0 rounded-4 mt-4">
                    <div className="card-body p-4">
                      <h6 className="fw-600 text-dark mb-0">
                        Authorized Signature
                      </h6>
                      <div
                        style={{
                          position: "relative",
                          marginTop: "12px",
                          width: "250px",
                          height: "60px",
                          borderRadius: "12px",
                          overflow: "hidden",
                          backgroundColor: "#F3F4F6",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedProfile(
                            poDetails.sign_image &&
                              poDetails.sign_image.trim() !== ""
                              ? poDetails.sign_image
                              : "",
                          );
                          setShowProfilePopup(true);
                        }}
                      >
                        {/* Image Preview */}
                        {
                          <img
                            src={poDetails.sign_image}
                            alt={""}
                            style={{
                              width: "100%",
                              height: "60px",
                              objectFit: "fit",
                            }}
                          />
                        }
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};
